import { render, staticRenderFns } from "./Horari.vue?vue&type=template&id=15eb6376&scoped=true"
import script from "./Horari.vue?vue&type=script&lang=js"
export * from "./Horari.vue?vue&type=script&lang=js"
import style0 from "./Horari.vue?vue&type=style&index=0&id=15eb6376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15eb6376",
  null
  
)

export default component.exports